// extracted by mini-css-extract-plugin
export default {"footer":"TheFooter_footer__96+16","row":"TheFooter_row__rbpSF"};